export default __webpack_public_path__ + "static/media/menu.ae5240ca.svg";